import lang from "@/views/modules/EdRequests/language/en";

let searchFieldsDef = {
    'request_no': {
        label: lang.LBL_REQUEST_NO,
    },
    'created_by': {
        label: lang.LBL_REQUEST_BY,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'edrequest_user_name',
        id: 'edrequest_created_by',
    },
    'assigned_user_id': {
        label: lang.LBL_REQUEST_TO,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'edrequest_assigned_user_name',
        id: 'edrequest_assigned_user_id',
    },
    'description': {
        label: lang.LBL_DESCRIPTION,
    },
    'status': {
        label: lang.LBL_REQUEST_STATUS,
        type:'select',
        field_infos:'ed_request_status'
    },
};
export default { searchFieldsDef }